<div class="table-container table-format-rows" *ngIf="statusDetail == 'success'">

    <div class="search-container">
      <mat-form-field appearance="outline" class="search-field alt-inter-medium alt-size-14" style="width: 300px">
        <mat-label>{{ 'Buscar por nombre, apellido o teléfono' | translate }}</mat-label>
        <input
          matInput
          (input)="onSearchQueryInput($event)"
          placeholder="Buscar por nombre, apellido o teléfono"
          width="300px"
        />
      </mat-form-field>
    </div>

  <table matSort (matSortChange)="sortData($event)" class mat-table [dataSource]="dataSource" [trackBy]="trackByFn">

    <!-- Fecha -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="created_At" style="width: 150px">Fecha de registro</th>
      <td mat-cell *matCellDef="let element">{{ element.created_At | date:'yyyy-MM-dd' }}</td>
    </ng-container>

    <!-- Nombre -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="surnames" style="width: 250px;">Nombre</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <!-- Compañía -->
    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef style="width: 150px">Compañía</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>

    <ng-container matColumnDef="telephone">
      <th mat-header-cell *matHeaderCellDef style="width: 150px">Telefono</th>
      <td mat-cell *matCellDef="let element">{{ element.telephone }}</td>
    </ng-container>

    <!-- Allied -->
    <ng-container matColumnDef="allied">
      <th mat-header-cell *matHeaderCellDef>Allied</th>
      <td mat-cell *matCellDef="let element">
        <select [ngModel]="element.allied_id || ''" (ngModelChange)="onAlliedChange($event, element)" class="custom-select">
          <option value="" disabled>SELECCIONAR</option>
          <option *ngFor="let allied of alliedList" [value]="allied.id">{{ allied.name }}</option>
        </select>
      </td>
    </ng-container>

    <!-- Grupo -->
    <ng-container matColumnDef="group">
      <th mat-header-cell *matHeaderCellDef>Grupo</th>
      <td mat-cell *matCellDef="let element">
        <select [ngModel]="element.group_id || ''" [disabled]="!element.allied_id" (ngModelChange)="onGroupChange($event, element)" class="custom-select">
          <option value="" disabled>SELECCIONAR</option>
          <option *ngFor="let group of getFilteredGroups(element.allied_id)" [value]="group.id">{{ group.name }}</option>
        </select>
      </td>
    </ng-container>

    <!-- Facilitador -->
    <ng-container matColumnDef="facilitator">
      <th mat-header-cell *matHeaderCellDef>Facilitador</th>
      <td mat-cell *matCellDef="let element">
        <select [id]="'allied_' + element.id" [ngModel]="element.facilitator_id || ''" [disabled]="!element.group_id" (ngModelChange)="onFacilitatorChange($event, element)" class="custom-select">
          <option value="" disabled>SELECCIONAR</option>
          <option *ngFor="let facilitator of getFilteredFacilitators(element.allied_id)" [value]="facilitator.id">{{ facilitator.name }}</option>
        </select>
      </td>
    </ng-container>

    <!-- Botón Actualizar -->
    <ng-container matColumnDef="update">
      <th mat-header-cell *matHeaderCellDef style="width: 75px">Actualizar</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button
                class="btn-update pointer"
                (click)="updateAnyCompany(element)"
                [disabled]="enableButtomUpdate(element)"
                [ngClass]="{'btn-update-disabled': enableButtomUpdate(element)}">
          Editar
        </button>
      </td>
    </ng-container>

    <!-- Botón Ocultar -->
    <ng-container matColumnDef="hide">
      <th mat-header-cell *matHeaderCellDef style="width: 75px">Ocultar</th>
      <td mat-cell *matCellDef="let element">
        <button mat-button
                class="btn-hide pointer"
                (click)="disabledCompany(element)">
          Ocultar
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      (page)="handlePageEvent($event)"
      [pageSize]="pageSize"
      [length]="length"
      [pageIndex]="pageIndex - 1"
      [showFirstLastButtons]=true
      aria-label="Select page"
      >></mat-paginator
    >
</div>
